import { ConcreteEncodable } from "./ConcreteEncodable";

import { TelemetryCatalogueEntryImplEncoder } from "../../encoder/TelemetryCatalogueEntryImplEncoder";

import * as CubiqTS from "../../index";
import { TelemetryCatalogueEntry } from "../TelemetryCatalogueEntry";

export class TelemetryCatalogueEntryImpl
  extends ConcreteEncodable
  implements TelemetryCatalogueEntry
{
  public static enType: string = "com.bcdfx.sysmon.impl.TelemetryCatalogueEntryImpl";

  /*FID=1*/
  public fQDN: string;
  /*FID=2*/
  public fqdnMask: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = TelemetryCatalogueEntryImplEncoder.Instance;
    this.setEncodableType(TelemetryCatalogueEntryImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "TelemetryCatalogueEntryImpl[" +
      "fQDN=" +
      this.fQDN +
      "fqdnMask=" +
      this.fqdnMask +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
